var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"whatsapp-floating-icon",attrs:{"href":'http://wa.me/' + _vm.constantes.whatsapp_number,"target":"_blank"}},[_c('Whatsapp'),_c('span',[_vm._v("Contactanos!")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }